module.exports = __webpack_public_path__ + "static/media/MyPethealth_Terms_of_Use.561a022e.pdf";